import type { CanvasSession, PhaseCode } from "./schema";
import { findField } from "./schema";

/**
 * Returns true if the (complexity, stage, fieldIndex) combination matches an
 * allowed skip rule per SKILL.md §Complexity-Driven Adjustments.
 * Today: solo_operator + S1.human_team_foundation only.
 */
export function canSkipField(session: CanvasSession, phase: PhaseCode, fieldIndex: number): boolean {
  if (session.complexity !== "solo_operator") return false;
  if (phase !== "S1") return false;
  try {
    const field = findField(phase, fieldIndex);
    return field.name === "human_team_foundation";
  } catch {
    return false;
  }
}
